import { DateFormatter } from '@mantine/dates';
import dayjs from 'dayjs';
import ptBR from 'dayjs/locale/pt-br';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('America/Sao_Paulo');

dayjs.extend(localizedFormat);
dayjs.locale(ptBR);

dayjs.extend(customParseFormat);

export const inputDateFormatter: DateFormatter = ({ type, date, format }) => {
  if (!date) return '';

  switch (type) {
    case 'default':
      return dayjs.tz(date as string).format(format);
    case 'multiple':
      return (date as Date[]).map((d) => dayjs.tz(d).format(format)).join(', ');
    case 'range':
      return (date as Date[]).map((d) => dayjs.tz(d).format(format)).join(' - ');
  }
};

export function formatDate(date: string | Date, format: string = 'L'): string {
  return dayjs.tz(date).format(format);
}

export function formatDateInLocalTime(date: string | Date, format: string = 'L'): string {
  const localTimeZone = dayjs.tz.guess() || 'America/Sao_Paulo';
  return dayjs.tz(date, localTimeZone).format(format);
}

export default dayjs;
